import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'Helpers/PropTypes';

export const SelectScenarioContext = React.createContext(null);

const init = () => {
  return {
    isSelecting: false,
  };
};

const SET_IS_SELECTING = 'set-is-selecting';

const reducer = (state, action) => {
  switch (action.type) {
    case SET_IS_SELECTING: {
      return {
        ...state,
        isSelecting: action.isSelecting,
      };
    }
    default: {
      throw new Error(`Unhandled SelectScenarioContext action type: ${action.type}`);
    }
  }
};

export function SelectScenarioContextProvider({
  children,
  onAgentReview, // This prop may be present if we are viewing an unvalidated scenario from the agent side
  onSelectSuccess, // What should we do after a scenario is successfully selected?
}) {
  const [state, dispatch] = React.useReducer(reducer, null, init);

  const setIsSelecting = (isSelecting) => {
    dispatch({ type: SET_IS_SELECTING, isSelecting });
  };

  const memoizedValue = React.useMemo(() => {
    return {
      isSelecting: state.isSelecting,
      setIsSelecting,
      onAgentReview,
      onSelectSuccess,
    };
  }, [
    state,
    setIsSelecting,
  ]);

  return (
    <SelectScenarioContext.Provider
      value={memoizedValue}
    >
      {children}
    </SelectScenarioContext.Provider>
  );
}

SelectScenarioContextProvider.defaultProps = {
  onAgentReview: noop,
};

SelectScenarioContextProvider.propTypes = {
  children: PropTypes.any.isRequired,
  onAgentReview: PropTypes.func,
  onSelectSuccess: PropTypes.func.isRequired,
};

function useSelectScenarioContext() {
  const context = React.useContext(SelectScenarioContext);
  if (!context) throw new Error('useSelectScenarioContext must be called from a SelectScenarioContext.Provider');
  return context;
}

export default useSelectScenarioContext;
